import { IOrderPartyData, IOrderPartyResponse } from './IOrderParty';
import {
  convertIAddressResponseToIPropertyAddressData,
  convertIPropertyAddressDataToIAddressResponse,
  IAddressResponse,
} from '../Address/IAddress';
import {
  convertISignatoryDataToISignatoryResponse,
  convertISignatoryResponseToISignatoryData,
  ISignatoryData,
  ISignatoryResponse,
} from '../ISignatory';
import { undefArrConversion, undefConversion } from '../../../utilities/shared/undefinedConversion';
import { IPropertyAddressData } from '../../address/IPropertyAddressData';
import { eEntityType } from '../../../ui-toolkit/enums/eEntityType';
import { ePartyType } from '../../../ui-toolkit/enums/ePartyType';

export interface IExternalAPIEntityPartyResponse extends IOrderPartyResponse {
  type: ePartyType.entity;
  entity_name: string;
  entity_type: eEntityType;
  signatories?: ISignatoryResponse[];
  address?: IAddressResponse;
}

export interface IExternalAPIEntityPartyData extends IOrderPartyData {
  type: ePartyType.entity;
  entityName: string;
  entityType: eEntityType;
  signatories?: ISignatoryData[];
  address?: IPropertyAddressData;
}

export const convertIExternalAPIEntityPartyResponseToIExternalAPIEntityPartyData = ({
  entity_name,
  entity_type,
  signatories,
  address,
  ...rest
}: IExternalAPIEntityPartyResponse): IExternalAPIEntityPartyData => ({
  entityName: entity_name,
  entityType: entity_type,
  signatories: undefArrConversion(convertISignatoryResponseToISignatoryData, signatories),
  address: undefConversion(convertIAddressResponseToIPropertyAddressData, address),
  ...rest,
});

export const convertIExternalAPIEntityPartyDataToIExternalAPIEntityPartyResponse = ({
  entityName,
  entityType,
  signatories,
  address,
  ...rest
}: IExternalAPIEntityPartyData): IExternalAPIEntityPartyResponse => ({
  entity_name: entityName,
  entity_type: entityType,
  signatories: undefArrConversion(convertISignatoryDataToISignatoryResponse, signatories),
  address: undefConversion(convertIPropertyAddressDataToIAddressResponse, address),
  ...rest,
});
